const disabledBaseState = {
  backgroundColor: 'gray.100',
  borderColor: 'product.border.solid',
  color: 'text.dark.bodySubtle',
  opacity: '50%',
}

export const Input = {
  baseStyle: {
    _placeholder: { color: 'product.text.dark.placeholder' },
    field: {
      color: 'product.text.dark.bodySolid',
      '&::-webkit-search-cancel-button, &::-webkit-search-decoration': {
        display: 'none',
      },
    },
    _focus: {
      _invalid: {
        borderColor: 'product.state.solid.error',
      },
    },
  },
  variants: {
    filled: {
      field: {
        borderWidth: '1px',
        borderColor: 'gray.500',
        backgroundColor: 'gray.125',
        _hover: {
          backgroundColor: 'gray.125',
        },
        _focus: {
          backgroundColor: 'gray.125',
        },
      },
    },
    outline: {
      field: {
        backgroundColor: 'white',
        borderColor: 'product.border.solid',
        borderWidth: '1px',
        boxShadow: 'unset',
        _invalid: {
          boxShadow: 'unset',
          borderColor: 'product.state.solid.error',
        },
        _placeholder: {
          color: 'product.text.dark.placeholder',
        },
        _hover: {
          backgroundColor: 'white',
          borderColor: 'product.secondary',
          _disabled: {
            ...disabledBaseState,
          },
        },
        _focus: {
          _invalid: {
            boxShadow: 'unset',
            borderColor: 'product.state.solid.error',
          },
          boxShadow: 'unset',
          borderColor: 'product.secondary',
          backgroundColor: 'white',
        },
        _readOnly: {
          color: 'product.text.dark.bodySolid',
        },
        _disabled: {
          ...disabledBaseState,
        },
        _focusVisible: {
          borderColor: 'cyan.100',
          boxShadow: '0 0 4px 0 var(--chakra-colors-cyan-600)',
        },
      },
    },
  },
  sizes: {
    md: {
      // #DESIGN_2023
      field: {
        height: 10,
        borderRadius: 'md',
        fontSize: 'product.md',
      },
    },
    sm: {
      field: {
        height: 8,
        borderRadius: 'md',
        fontSize: 'sm',
      },
    },
    xs: {
      field: {
        borderRadius: 'md',
        fontSize: 'xs',
      },
    },
  },
}
